<app-menu *ngIf="!condition"></app-menu>
<!-- <app-phone-numbers></app-phone-numbers> -->
<router-outlet></router-outlet>
<app-footer></app-footer>
